import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '../../shared/services/app-config.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  constructor( public appConfigService: AppConfigService ) { }

  ngOnInit() {

  }

}
